// SPDX-License-Identifier: AGPL-3.0-or-later

/**
 * Animated cosmetic URL → small static poster (first frame). Lists show the poster and only download the
 * animated asset once the item is hovered/active, like Discord. Filled by the catalog stores.
 */
const posters = new Map<string, string>();

export function registerCosmeticPoster(image: string, poster: string | undefined): void {
	if (poster) posters.set(image, poster);
	else posters.delete(image);
}

export function getCosmeticPoster(image: string): string | undefined {
	return posters.get(image);
}
